import { SUPPLEMENT_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";


export const addInventory = async (quantity: number, id: string) => {
  const api = axiosAuth()
  
  const res = await api.post(`${SUPPLEMENT_BASE_URL}/inventory`, {
      productId: id,
      quantity,
    });

    return res.data;
};

export const getInventory = async (id: string) => {

  const api = axiosAuth();

    const res = await api.get(
      `${SUPPLEMENT_BASE_URL}/inventory?productId=${id}`,
    );

    return res.data;
};

export const updateInventory = async (quantity: number, id: string) => {

  const api = axiosAuth();

   const res = await api.put(`${SUPPLEMENT_BASE_URL}/inventory`, {
     productId: id,
     quantity,
   });

   return res.data;
}

